module.exports = __webpack_public_path__ + "img/png-8.d95ca2bc.png";